import { MODAL_LOAD_EVENT } from '../dialogs/lib';
import * as addSlider from '../sliders/sliders';
import { initDropdowns } from '../dropdowns/lib';
import addSelectDropdowns from '../dropdowns/select';
import { renderProductCta } from '../product/cta/ProductCta';
import { PRODUCT_STATE_CHANGE, VARIANT_SWITCH } from '../../events';
import analytics from '../../analytics';
import routes from '../../routes';
const product = window.product;
function toggleShopTheLookButton(button, variantId) {
    const variant = product.variants.find((productVariant) => productVariant.id === variantId);
    if (variant.mediaVariants) {
        const params = new URLSearchParams();
        variant.mediaVariants.forEach(mediaVariant => params.append('codes[]', mediaVariant));
        button.dataset.modalUrl = `${routes.shop_the_look}?${params.toString()}`;
        button.classList.remove('!hidden');
    }
    else {
        button.classList.add('!hidden');
    }
}
export default function () {
    // Button, since we don't replace the slider on variant switch, we need to hide / show the button according to variant state
    const button = document.querySelector('button[data-role="shop-the-look"]');
    if (button) {
        toggleShopTheLookButton(button, product.selectedVariant.id);
        document.addEventListener(VARIANT_SWITCH, (e) => {
            toggleShopTheLookButton(button, Number(e.detail.variantId));
        });
    }
    // Dialog
    const dialog = document.querySelector('#ajax-modal2');
    if (dialog) {
        dialog.addEventListener(MODAL_LOAD_EVENT, (e) => {
            if (e.detail.role === 'shop-the-look') {
                // init modal slider
                addSlider.shopTheLook();
                // init modal dropdowns
                initDropdowns();
                addSelectDropdowns(dialog);
                // display CTA buttons
                renderProductCta({ container: dialog, inDialogContext: true });
                // Update CTA on ean change
                dialog.querySelectorAll('input[name="ean[]"]').forEach((input) => {
                    input.addEventListener('change', (changeEvent) => {
                        document.dispatchEvent(new CustomEvent(PRODUCT_STATE_CHANGE, {
                            detail: {
                                productHash: changeEvent.target.dataset.productHash,
                                currentItemHash: changeEvent.target.dataset.itemHash,
                            },
                        }));
                    });
                });
                analytics.shopTheLook(JSON.parse(document.querySelector('[data-tracking]').dataset.tracking));
                dialog.querySelectorAll('[data-product-cta]').forEach((button) => {
                    button.addEventListener('click', () => {
                        analytics.shopTheLookProductClicked(JSON.parse(button.dataset.product).selectedVariant.tracking);
                    });
                });
            }
        });
    }
}
